import { render, staticRenderFns } from "./alertDetails.vue?vue&type=template&id=6fb239b0&scoped=true"
import script from "./alertDetails.vue?vue&type=script&lang=js"
export * from "./alertDetails.vue?vue&type=script&lang=js"
import style0 from "./alertDetails.vue?vue&type=style&index=0&id=6fb239b0&lang=scss&scoped=true"
import style1 from "./alertDetails.vue?vue&type=style&index=1&id=6fb239b0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb239b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb239b0')) {
      api.createRecord('6fb239b0', component.options)
    } else {
      api.reload('6fb239b0', component.options)
    }
    module.hot.accept("./alertDetails.vue?vue&type=template&id=6fb239b0&scoped=true", function () {
      api.rerender('6fb239b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/assurance/components/moi-details/alertDetails.vue"
export default component.exports